import { ArrayUtil } from "../ArrayUtil";
import { ClientInfo } from "./ClientInfoReply";
import { ClientType } from "./ClientType";
import { InstanceIdentifier } from "../InstanceIdentifier";

export interface AdminRequestInterface {
    originator: ClientInfo;
    requestId: string;
    targetClients: ClientInfo[];
    targetClientTypes: string[];
    type: string;
}

export abstract class AdminRequest implements AdminRequestInterface {
    originator: ClientInfo;
    requestId: string;
    targetClients: ClientInfo[];
    targetClientTypes: string[];
    type: string;

    constructor(message: any) {
        this.originator = message.originator;
        this.requestId = message.requestId;
        this.targetClients = message.targetClients;
        this.targetClientTypes = message.targetClientTypes;
        this.type = message.type;
    }

    isForMe(): boolean {
        if (!ArrayUtil.isEmptyArray(this.targetClientTypes) &&
            !this.targetClientTypes.includes(ClientType.WEB_CLIENT)) {
            return false;
        }
        if (this.targetClients == null) {
            return true;
        }
        for (const client of this.targetClients) {
            if (client.vmIdentifier === InstanceIdentifier.get()) {
                return true;
            }
        }
        return false;
    }

    abstract handle(): void;
}
